

import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-select-item',
  templateUrl: './select-item.component.html',
  styleUrls: ['./select-item.component.scss']
})
export class SelectItemComponent implements OnInit {
  items: any[] = [];
  visibleField: string = '';
  constructor(
    private dynamicDialogRef: DynamicDialogRef,
    private dynamicDialogConfig: DynamicDialogConfig,
  ) { }

  ngOnInit() {
    const { items, visibleField } = this.dynamicDialogConfig.data;

    this.items = items;
    this.visibleField = visibleField;
  }

  selectItem(item: any) {
    if (item.disabled) {
      return;
    }
    this.dynamicDialogRef.close(item);
  }
}
